export const PUBLIC_NAVBAR_WIDTH = "1044px";

export const PUBLIC_AUTH_FORM_WIDTH = "520px";

export const PUBLIC_FORM_MAX_WIDTH = "520px";

export const PUBLIC_CONTENT_SPACING = {
  px: { base: 4, md: 6, lg: 8 },
  pt: { base: "132px", md: "150px" },
  pb: { base: 18, md: 12 },
  gap: { base: 5, md: 6 },
  cardPadding: { base: 5, md: 7, lg: 8 },
} as const;
